// コメント位置はPrettier対策
class AppCertification {
  //FIXME 本番設定に書き換えてください。
  /**
   * アプリケーションの定数値です。
   */
  APPVERSION = "26.04.01";
  APP_CONFIG = {
    //FIXME MockModeの有効無効
    // HttpClientのgetを対象として、dummy.jsonを読み込むフラグです。
    MOCK_MODE: false,

    /**
     * API接続用設定（VDI外アクセス）
     */
    // ryst環境(RY02）
    BASE_URL: "https://cirrus-wh-st.nkr.nikkon-is.com/",
  };

  /**
   * Cognitoの設定です。
   */
  //FIXME 本番設定に書き換えてください。
  //営業所用
  COGNITO = {
    USER_POOL_ID: "ap-northeast-1_g126l4wSq",
    APP_CLIENT_ID: "7peegdd8p1qpdl67fsjm8uot7t",
  };

  //荷主用
  SHIPPER_COGNITO = {
    USER_POOL_ID: "ap-northeast-1_58pdx9aJP",
    APP_CLIENT_ID: "16jb9s2lvv24l5ss5bt64748oa",
  };

  /** datadog */
  DATADOG = {
    DD_APPLICATION_ID: "5153b534-a0c9-4d26-8270-1a8bb6dc0ebb",
    DD_CLIENT_TOKEN: "pub2c87c651f5b8ac1d9feda5417ad0aa66",
    DD_SERVICE: "wh-ryst-pc",
    DD_ENV: "wh-ryst",
    DD_SESSION: 20,
  };
  /** datadog */
}

export const appCertification = new AppCertification();
